import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ClipLoader } from 'react-spinners';
import {
  useAddSubscriptionsMutation,
  useDeleteSubscriptionsMutation
} from '../../../redux/login/subscriptions/SubscriptionsServiceApi';
import {
  subscriptionsInformation,
  subscriptionsSlice
} from '../../../redux/slices/subscriptionsSlice';
import { VM } from '../../../viewmodel/VM';
import Button from '../../components/commons/Button';
import ButtonIcon from '../../components/commons/ButtonIcon';
import CheckBox from '../../components/commons/CheckBox';
import { useTranslate } from '../../context/languageContext';
import { useSetModalChild, useSetModalOpened } from '../../context/modalContext';
import { R } from '../../R';
import { useTheme } from '../../context/themeContext';
import { agencyInformation } from '../../../redux/slices/agencySlice';
import { favFilterNewsAlertsState, favSubsNewsState, favoritesInformation, favoritesSlice } from '../../../redux/slices/favoritesSlice';
import { typologiesInformation } from '../../../redux/slices/typologySlice';

enum Options {
  OPERATOR = 0,
  TYPOLOGY = 1,
}

interface IFilterOptions {
  id: number;
  label: string;
}

export default function SubscribeNews(props: any) {
  const Close = R.drawables.general.Ic_close;
  const [selectedOperators, setSelectedOperators] = useState([] as any);
  const t = useTranslate();
  const subscriptions = useSelector(subscriptionsInformation);
  const [renderOperators, setRenderOperators] = useState(null as any);
  const setOpened = useSetModalOpened();
  const setChild = useSetModalChild();
  const theme = useTheme();
  const agencyState = useSelector(agencyInformation);
  const favSubsNews = useSelector(favSubsNewsState);
  const [favFilterSelector, setFavFilterSelector] = useState(favSubsNews);
  const favAgencies = useSelector(favoritesInformation).agencyId;

  const dispatch = useDispatch();
  const [addSubscription] = useAddSubscriptionsMutation();
  const [deleteSubscription] = useDeleteSubscriptionsMutation();

  const typologies = useSelector(typologiesInformation);
  const [selectedOption, setSelectedOption] = useState(Options.OPERATOR);
  const [renderTypologies, setRenderTypologies] = useState(null as any);
  const [selectedTypologies, setSelectedTypologies] = useState<Array<number>>(subscriptions.typologyNotices);
  const [selectAllTypologies, setSelectAllTypologies] = useState(selectedTypologies.length === typologies.length);

  const options: Array<IFilterOptions> = [
    {
      id: Options.OPERATOR,
      label: t('operators'),
    },
    {
      id: Options.TYPOLOGY,
      label: t('typologies'),
    },
  ];

  let copyAgenciesFilters = JSON.parse(JSON.stringify(agencyState.agenciesFilters));
  let agenciesTransport: Array<any> = [];
  copyAgenciesFilters.forEach((transportModeAg: any) => {
    if (transportModeAg.id !== 5) {
      transportModeAg.agencies.shift();
      let filterDuplicates: Array<number> = [];

      agenciesTransport.forEach((agency: any) => {
        let indexFound = transportModeAg.agencies.findIndex(
          (transAg: any) => transAg.id === agency.id
        );
        if (indexFound !== -1) {
          filterDuplicates.push(indexFound);
        }
      });
      if (filterDuplicates?.length) {
        filterDuplicates.forEach((indexToDel: number) => {
          transportModeAg.agencies.splice(indexToDel, 1);
        });
      }

      let filteredAgenciesWithNewsOrAlerts = transportModeAg.agencies.filter((agency: any) =>
        agencyState.dataOrigin?.find(
          (ori: any) => agency?.id === ori?.agencyId && (ori?.driverId === 4 || ori?.driverId === 6)
        )
      );

      agenciesTransport = agenciesTransport.concat(filteredAgenciesWithNewsOrAlerts);
    }
  });
  agenciesTransport.sort(function (a, b) {
    let nameA = a?.longName?.toLowerCase();
    let nameB = b?.longName?.toLowerCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  });

  useEffect(() => {
    async function fetchData() {
      setRenderOperators(await getRenderOperators());
    }
    if (!selectedOperators.length) setSelectedOperators(getCheckbox());
    else fetchData();
  }, [selectedOperators, subscriptions]);

  useEffect(() => {
    async function fetchData() {
      setRenderTypologies(await getRenderTypologies());
    }
    fetchData();
  }, [selectedTypologies, subscriptions]);

  const getCheckbox = () => {
    const res = [];
    for (let agency in agenciesTransport) {
      res[agenciesTransport[agency].id] = {
        agency: agenciesTransport[agency].id,
        selected: subscriptions.agencyNotices.includes(agenciesTransport[agency].id as never)
      };
    }
    return res;
  };

  const changeAllCheckbox = (value: boolean) => {
    const res = [];
    for (let agency in agenciesTransport) {
      res[agenciesTransport[agency].id] = {
        agency: agenciesTransport[agency].id,
        selected: value
      };
    }
    return res;
  };

  const isActive = () => {
    let operatorsToRemove: any[] = [];
    let operatorsToAdd = [];
    let typologiesToRemove: any[] = [];
    let typologiesToAdd = [];
    let updateSubscriptions = JSON.parse(JSON.stringify(subscriptions));

    for (let agency in selectedOperators) {
      if (
        updateSubscriptions.agencyNotices.includes(selectedOperators[agency]?.agency) &&
        !selectedOperators[agency]?.selected
      ) {
        operatorsToRemove.push(selectedOperators[agency]?.agency);
      } else if (
        !updateSubscriptions.agencyNotices.includes(selectedOperators[agency]?.agency) &&
        selectedOperators[agency]?.selected
      ) {
        operatorsToAdd.push(selectedOperators[agency]?.agency);
      }
    }

    typologiesToAdd = selectedTypologies.filter(typology =>
      !updateSubscriptions.typologyNotices.includes(typology)
    );

    typologiesToRemove = updateSubscriptions.typologyNotices.filter((typology: number) =>
      !selectedTypologies.includes(typology)
    );

    updateSubscriptions.agencyNotices = updateSubscriptions.agencyNotices.concat(operatorsToAdd);
    updateSubscriptions.agencyNotices = updateSubscriptions.agencyNotices.filter((x: any) => !operatorsToRemove.includes(x));

    updateSubscriptions.typologyNotices = updateSubscriptions.typologyNotices.concat(typologiesToAdd);
    updateSubscriptions.typologyNotices = updateSubscriptions.typologyNotices.filter((x: any) => !typologiesToRemove.includes(x));

    return subscriptions.agencyNotices.toString() === updateSubscriptions.agencyNotices.toString() && subscriptions.typologyNotices.toString() === updateSubscriptions.typologyNotices.toString();

  };

  const updateSubs = () => {
    let operatorsToRemove: any[] = [];
    let operatorsToAdd = [];
    let typologiesToRemove: any[] = [];
    let typologiesToAdd = [];
    let updateSubscriptions = JSON.parse(JSON.stringify(subscriptions));
    for (let agency in selectedOperators) {
      let filtered = JSON.parse(JSON.stringify(Array.from(VM.dataOrigin.noMap))).find(
        ({ agencyId }: any) => agencyId === VM.agencies.data[selectedOperators[agency]?.agency]?.id
      );
      if (
        updateSubscriptions.agencyNotices.includes(selectedOperators[agency]?.agency) &&
        !selectedOperators[agency]?.selected
      ) {
        if (filtered) operatorsToRemove.push(filtered.agencyId);
      } else if (
        !updateSubscriptions.agencyNotices.includes(selectedOperators[agency]?.agency) &&
        selectedOperators[agency]?.selected
      ) {
        if (filtered) operatorsToAdd.push(filtered.agencyId);
      }
    }

    typologiesToAdd = selectedTypologies.filter(typology =>
      !updateSubscriptions.typologyNotices.includes(typology)
    );

    typologiesToRemove = updateSubscriptions.typologyNotices.filter((typology: number) =>
      !selectedTypologies.includes(typology)
    );

    updateSubscriptions.agencyNotices = updateSubscriptions.agencyNotices.concat(operatorsToAdd);
    updateSubscriptions.agencyNotices = updateSubscriptions.agencyNotices.filter(
      (x: any) => !operatorsToRemove.includes(x)
    );

    updateSubscriptions.typologyNotices = updateSubscriptions.typologyNotices.concat(typologiesToAdd);
    updateSubscriptions.typologyNotices = updateSubscriptions.typologyNotices.filter((x: any) => !typologiesToRemove.includes(x));

    addSubscription({
      stops: [],
      lines: [],
      agencyNotices: operatorsToAdd,
      typologyNotices: typologiesToAdd
    });
    deleteSubscription({
      stops: [],
      lines: [],
      agencyNotices: operatorsToRemove,
      typologyNotices: typologiesToRemove
    });
    dispatch(subscriptionsSlice.actions.updateSubscriptions(updateSubscriptions));
    if (favFilterSelector) {
      dispatch(favoritesSlice.actions.updateFavSubsNews(true));
    } else {
      dispatch(favoritesSlice.actions.updateFavSubsNews(false));
    }
    setOpened(false);
    setChild(null);
  };

  const changeFavCheckbox = (value: boolean) => {
    let res: Array<number> = [];

    const agencyIdsFav: Array<number> = [];

    favAgencies.forEach((originId: number) => {
      const agency: any = agencyState.dataOrigin.find((element: any) => element.id === originId);
      if (agency) {
        const agencyIsAdded = agencyIdsFav.find((element: number) => element === agency?.agencyId);

        const existsAgency = agenciesTransport.find((element) => element.id === agency?.agencyId);

        if (!agencyIsAdded && existsAgency) {
          agencyIdsFav.push(agency?.agencyId);
        }
      }
    });

    const copySel = JSON.parse(JSON.stringify((selectedOperators)));
    agencyIdsFav.forEach((sel: number) => {
      let isAddedIndex = selectedOperators?.findIndex(
        (element: any) => element?.agency === sel
      );

      if (isAddedIndex !== -1) {
        copySel[isAddedIndex].selected = value;
      }
    });

    res = copySel;

    return res;
  };

  function renderHeaderSections() {
    return (
      <>
        {/* Título principal antes de las pestañas */}
        <div className={'title marginBottom10'}>{t('subscribeNews')}</div>

        <div className={'operatorHeader marginTop10'}>
          {options.map((option) => {
            return (
              <div
                key={option.id}
                onClick={() => {
                  if (selectedOption !== option.id) {
                    setSelectedOption(option.id);
                  }
                }}
                className="transit-option-sectionNews"
                style={{
                  ...{
                    flexDirection: 'row',
                    marginTop: 5,
                    flex: 1,
                    wordBreak: 'break-word',
                    justifyContent: 'center',
                    textAlign: 'center',
                    cursor: 'pointer'
                  },
                  ...(selectedOption === option.id
                    ? { borderWidth: '0px 0px 2px 0px', borderBottomStyle: 'solid', borderBottomColor: '#0078b2' }
                    : {})
                }}>
                <div
                  className={'subtitle'}
                  style={{ ...(selectedOption !== option.id ? { opacity: 0.5 } : { opacity: 1 }) }}>
                  {option.label}
                </div>
              </div>
            );
          })}
        </div>

        <div className={'description marginTop10'}>
          {selectedOption === Options.OPERATOR
            ? t('selectOpNews')
            : t('selectTypologyNews')}
        </div>
      </>
    );
  }



  const getRenderOperators = async () => {
    let res = [];

    const agenciesSort: Array<any> = JSON.parse(JSON.stringify(agenciesTransport));

    for (let agency in agenciesSort) {
      let icon = await VM.icons.getIcon(agenciesSort[agency].id, 'agency');

      let filtered = JSON.parse(JSON.stringify(Array.from(VM.dataOrigin.noMap))).filter(
        ({ agencyId, driverId }: any) =>
          agencyId === agenciesSort[agency].id && (driverId === 4 || driverId === 6)
      );
      if (filtered.length) {
        let elementSubscribedIndex = selectedOperators?.findIndex(
          (element: any) => element?.agency === agenciesSort[agency].id
        );
        res.push(
          <div key={agency}>
            <div className={'row'}>
              <ButtonIcon style={{ marginRight: 5 }} iconSize={20} size={30} icon={icon} />
              <div className={'primaryText'} style={{ textTransform: 'capitalize' }}>
                {agenciesSort[agency]?.groupName
                  ? agenciesSort[agency]?.groupName
                  : agenciesSort[agency].shortName}
              </div>

              <div className={'close'} style={{ cursor: 'auto' }}>
                <CheckBox
                  onSelected={() => {
                    let aux = JSON.parse(JSON.stringify(selectedOperators));
                    aux[elementSubscribedIndex].selected = true;
                    setSelectedOperators(aux);
                  }}
                  onUnselected={() => {
                    let aux = JSON.parse(JSON.stringify(selectedOperators));
                    aux[elementSubscribedIndex].selected = false;
                    setSelectedOperators(aux);
                  }}
                  checked={selectedOperators[elementSubscribedIndex]?.selected}
                />
              </div>
            </div>
            <div className={'divider'} />
          </div>
        );
      }
    }
    return res;
  };

  const getRenderTypologies = async () => {
    let res = [];
    for (let typology of typologies) {
      let isSelected = selectedTypologies.find((sel: number) => sel === typology.id) !== undefined;
      res.push(
        <div key={typology.id}>
          <div className={'row'}>
            <div className={'primaryText'} style={{ textTransform: 'capitalize', marginLeft: 30 }}>
              {typology.name}
            </div>

            <div className={'close'} style={{ cursor: 'auto' }}>
              <CheckBox
                onSelected={() => {
                  let aux = JSON.parse(JSON.stringify(selectedTypologies));
                  aux.push(typology.id);
                  setSelectedTypologies(aux);
                }}
                onUnselected={() => {
                  let aux: Array<number> = JSON.parse(JSON.stringify(selectedTypologies));
                  let foundIndex = selectedTypologies.findIndex(
                    (sel: number) => sel === typology.id
                  );
                  aux.splice(foundIndex, 1);
                  setSelectedTypologies(aux);
                  if (selectAllTypologies) {
                    setSelectAllTypologies(false);
                  }
                }}
                checked={isSelected}
              />
            </div>
          </div>
          <div className={'divider'} />
        </div>
      );
    }
    return res;
  };

  const changeAllCheckboxForTypologies = (value: boolean) => {
    let res: Array<number> = [];
    if (value) {
      res = typologies.map((typology) => typology.id);
    }
    return res;
  };

  function renderContentSection() {
    let content;

    switch (selectedOption) {
      case Options.TYPOLOGY:
        content = (
          <>
            <div className={'subs-news-body-for-alert-modal'}>
              <div className={'row'}>
                <div className={'primaryText'}>
                  {t('selectAll')}
                </div>
                <div className={'close'} style={{ cursor: 'auto' }}>
                  <CheckBox
                    onSelected={() => {
                      setSelectAllTypologies(true);
                      setSelectedTypologies(changeAllCheckboxForTypologies(true));
                    }}
                    onUnselected={() => {
                      setSelectAllTypologies(false);
                      setSelectedTypologies(changeAllCheckboxForTypologies(false));
                    }}
                    checked={selectAllTypologies}
                  />
                </div>
              </div>
              <div className={'divider'} />
              {renderTypologies ? (
                renderTypologies
              ) : (
                <div style={{ justifyContent: 'center', display: 'flex' }}>
                  <ClipLoader />
                </div>
              )}
            </div>
          </>
        );
        break;

      case Options.OPERATOR:
      default:
        content = (
          <>
            <div className={'subs-news-body-for-alert-modal'}>
              <div className={'row'}>
                <div className={'primaryText'}>{t('selectAllFavorites')}</div>
                <div className={'close'} style={{ cursor: 'auto' }}>
                  <CheckBox
                    onSelected={() => {
                      setFavFilterSelector(true);
                    }}
                    onUnselected={() => {
                      setSelectedOperators(changeFavCheckbox(false));
                      setFavFilterSelector(false);
                    }}
                    checked={favFilterSelector}
                  />
                </div>
              </div>
              <div className={'divider'} />{' '}
              <div className={'row'}>
                <div className={'primaryText'}>{t('selectAll')}</div>
                <div className={'close'} style={{ cursor: 'auto' }}>
                  <CheckBox
                    onSelected={() => setSelectedOperators(changeAllCheckbox(true))}
                    onUnselected={() => setSelectedOperators(changeAllCheckbox(false))}
                  />
                </div>
              </div>
              <div className={'divider'} />
              {renderOperators ? (
                renderOperators
              ) : (
                <div style={{ justifyContent: 'center', display: 'flex' }}>
                  <ClipLoader />
                </div>
              )}
            </div>
          </>
        );
    }

    return content;
  }

  useEffect(() => {
    if (favFilterSelector) {
      setSelectedOperators(changeFavCheckbox(true));
    }
  }, [favFilterSelector]);

  return (
    <div className={'subs-news'}>
      <div className={'subs-news-header'}>
        <Close
          className={'close'}
          onClick={() => {
            setOpened(false);
            setChild(null);
          }}
        />
        {renderHeaderSections()}
      </div>

      {renderContentSection()}

      <Button
        className={'paddingVertical10 paddingInLine20'}
        textColor={theme.colors.white}
        background={theme.colors.mediumDark}
        onClick={() => updateSubs()}
        disabled={isActive()}
        style={{ width: '94%' }}
        text={t('save')}
      />
    </div>
  );

}
